var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "b-button",
        {
          attrs: { variant: "primary", disabled: _vm.disabled || _vm.loading },
          on: { click: _vm.reloadDataSheets },
        },
        [
          _vm.loading ? _c("b-spinner") : _vm._e(),
          _vm._v("\n    データシートの取得 " + _vm._s(_vm.history) + "\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          attrs: {
            variant: _vm.datasheetsPreviewEnabled ? "success" : "",
            disabled: _vm.disabled || _vm.loading || _vm.updatedAt === null,
          },
          on: {
            click: function ($event) {
              return _vm.switchDatasheetsPreview()
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.datasheetsPreviewEnabled ? "✔ " : "") +
              "データシートプレビュー(最大10件まで)\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }